const API_BASE = import.meta.env.VITE_API_URL || 'https://api-dntools.agentyx.work/api';
async function request(path, options = {}) {
    const { method = 'GET', body, headers = {} } = options;
    const token = localStorage.getItem('access_token');
    const res = await fetch(`${API_BASE}${path}`, {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...headers,
        },
        body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json();
    if (!res.ok) {
        // Try to refresh token on 401
        if (res.status === 401 && token) {
            const refreshToken = localStorage.getItem('refresh_token');
            if (refreshToken) {
                const refreshRes = await fetch(`${API_BASE}/auth/refresh`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ refresh_token: refreshToken }),
                });
                if (refreshRes.ok) {
                    const refreshData = await refreshRes.json();
                    localStorage.setItem('access_token', refreshData.data.access_token);
                    localStorage.setItem('refresh_token', refreshData.data.refresh_token);
                    // Retry original request
                    return request(path, options);
                }
            }
            // Refresh failed - clear auth
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            window.location.href = '/login';
        }
        throw new ApiError(data.error?.code || 'UNKNOWN', data.error?.message || 'Request failed', res.status);
    }
    return data;
}
export class ApiError extends Error {
    code;
    status;
    constructor(code, message, status) {
        super(message);
        this.code = code;
        this.status = status;
        this.name = 'ApiError';
    }
}
export const api = {
    // Auth
    register: (data) => request('/auth/register', { method: 'POST', body: data }),
    login: (data) => request('/auth/login', { method: 'POST', body: data }),
    verifyEmail: (token) => request('/auth/verify-email', { method: 'POST', body: { token } }),
    forgotPassword: (email) => request('/auth/forgot-password', { method: 'POST', body: { email } }),
    resetPassword: (token, password) => request('/auth/reset-password', { method: 'POST', body: { token, password } }),
    // Scans
    submitScan: (domain, checks) => request('/scans', { method: 'POST', body: { domain, checks } }),
    getScanStatus: (jobId) => request(`/scans/${jobId}`),
    listScans: (page = 1, perPage = 20) => request(`/scans?page=${page}&per_page=${perPage}`),
    // Reports
    getReport: (jobId) => request(`/reports/${jobId}`),
    // User
    getProfile: () => request('/user/profile'),
    updateProfile: (data) => request('/user/profile', { method: 'PATCH', body: data }),
    getUsage: () => request('/user/usage'),
    // API Keys
    listApiKeys: () => request('/api-keys'),
    createApiKey: (data) => request('/api-keys', { method: 'POST', body: data }),
    deleteApiKey: (id) => request(`/api-keys/${id}`, { method: 'DELETE' }),
    // Public
    getResolvers: () => request('/resolvers'),
    getPlans: () => request('/plans'),
    getHealth: () => request('/health'),
    // Admin
    getAdminAnalytics: () => request('/admin/analytics'),
    getAdminUsers: (page = 1) => request(`/admin/users?page=${page}`),
    getAdminResolvers: () => request('/admin/resolvers'),
    updateAdminUser: (id, data) => request(`/admin/users/${id}`, { method: 'PATCH', body: data }),
    updateAdminResolver: (id, data) => request(`/admin/resolvers/${id}`, { method: 'PATCH', body: data }),
};
